<template>
  <CMSComponent v-if="resource" :resource="resource">
    <LazyHydrate when-visible>
      <component :is="blockName" :resource="resource">
        <template v-if="resource.filteredChildren && resource.filteredChildren.length">
          <Blocks
            v-for="child in resource.filteredChildren"
            :key="child.id"
            :resource="child"
          />
        </template>
      </component>
    </LazyHydrate>
  </CMSComponent>
</template>

<script>
import LazyHydrate from "vue-lazy-hydration";
import blocksMixin from '@i22/frontend-cms-utils/mixins/blocks-mixin'
import CMSComponent from "@i22/frontend-cms-utils/components/cms-component";
import Unknown from "@i22/frontend-cms-utils/components/unknown";
import Page from "beisheim/components/blocks/page";
import Root from "beisheim/components/blocks/root";
import Folder from "beisheim/components/blocks/folder";
import Stage from "beisheim/components/blocks/stage";
import Accordion from "beisheim/components/blocks/accordion";
import Intro from "beisheim/components/blocks/intro";
import TitledMarkdown from "beisheim/components/blocks/titled-markdown";
import TeaserTileSoloList from "beisheim/components/blocks/teaser-tile-solo-list";
import TeaserTileList from "beisheim/components/blocks/teaser-tile-list";
import TeaserList from "beisheim/components/blocks/teaser-list";
import Projects from "beisheim/components/blocks/projects";
import Gallery from "beisheim/components/blocks/gallery";
import BlockQuote from "beisheim/components/blocks/blockquote";
import Timeline from "beisheim/components/blocks/timeline";
import ContactPerson from "beisheim/components/blocks/contact-person";
import Media from "beisheim/components/blocks/media";
import SponsorshipApplicationSteps from "beisheim/components/blocks/sponsorship-application-steps";
import Factsheet from "beisheim/components/blocks/factsheet";
import Project from "beisheim/components/blocks/project";
import Iframe from "beisheim/components/blocks/iframe";
import LabeledList from "beisheim/components/blocks/labeled-list";
import LabeledListItem from "beisheim/components/blocks/labeled-list-item";
import LabeledListText from "beisheim/components/blocks/labeled-list-text";
import LabeledListMedia from "beisheim/components/blocks/labeled-list-media";
import FilesList from "beisheim/components/blocks/files-list";
import MediaWithTitledMarkdown from "beisheim/components/blocks/media-with-titled-markdown";
import RelatedContent from "beisheim/components/blocks/related-content";
import ScrollSpy from "beisheim/components/blocks/scroll-spy";
import IconTiles from "beisheim/components/blocks/icon-tiles";
import TeamMember from "beisheim/components/blocks/team-member";
import ProjectWall from "beisheim/components/blocks/project-wall";
import TeamPhoto from "beisheim/components/blocks/team-photo";
import TeamList from "beisheim/components/blocks/team-list";
import Search from "beisheim/components/blocks/search";
import NewsCategory from "beisheim/components/blocks/news-category";
import NewsList from "beisheim/components/blocks/news-list";

const HomePage = Page;
const FocusPage = Page;
const ProjectsPage = Page;
const TeamsPage = Page;
const SponsorshipPage = Page;
const FoundationPage = Page;
const StrategyPage = Page;
const InvestmentPage = Page;
const AboutPage = Page;
const News = Page;

export default {
  name: "Blocks",
  components: {
    CMSComponent,
    LazyHydrate,
    Unknown,
    HomePage,
    Project,
    Iframe,
    Page,
    DownloadsPage: Page,
    Root,
    Folder,
    Intro,
    TeaserTileList,
    TeaserTileSoloList,
    TitledMarkdown,
    TeaserList,
    Stage,
    Projects,
    Accordion,
    Gallery,
    SponsorshipApplicationSteps,
    BlockQuote,
    Factsheet,
    Media,
    Timeline,
    ContactPerson,
    LabeledList,
    LabeledListItem,
    LabeledListText,
    LabeledListMedia,
    FilesList,
    MediaWithTitledMarkdown,
    RelatedContent,
    ScrollSpy,
    IconTiles,
    TeamList,
    TeamMember,
    ProjectWall,
    TeamPhoto,
    Search,
    FocusPage,
    ProjectsPage,
    SponsorshipPage,
    FoundationPage,
    StrategyPage,
    InvestmentPage,
    AboutPage,
    TeamsPage,
    NewsCategory,
    NewsList,
    News,
  },
  mixins: [ blocksMixin ]
};
</script>
